module.exports = __webpack_public_path__ + "img/condos-min.00d50ce1.jpg";